/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
import Storage from './helpers/Storage'

window.axios = require('axios')
window.axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'Accept'          : 'application/json',
}

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  config.baseURL = '/api/'
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || null

  if (timezone) {
    config.headers['TimeZone'] = timezone
  }
  const token                     = Storage.get('imagesim_markup_tool_token')
  config.headers['Authorization'] = 'Bearer ' + token
  return config
}, function (error) {
  return Promise.reject(error)
})

// update jwt token every 1 hour
// setInterval(() => {
//   axios.get('/auth/refresh').then(response => {
//     const access_token = response.data.data.access_token
//
//     window.Imagesim.token = access_token
//
//     window.axios.defaults.headers.common = {
//       'Authorization'   : `Bearer ${access_token}`,
//       'X-Requested-With': 'XMLHttpRequest',
//       'Accept'          : 'application/json',
//     }
//   }).catch(error => {
//     // ignore errors
//     console.error(error)
//   })
// }, 1000 * 60 * 60)

window.handleError = (response, router) => {
  if (navigator && !navigator.onLine) {
    alert('Network error. Please make sure you are connected to the internet')
    return
  }

  if (!response) {
    router.push('/500')
    return
  }

  if (response.status === 200) {
    return
  }

  if (response.status === 422) {
    return
  }

  if (response.status === 500) {
    router.push('/500')
    return
  }

  if (response.status === 404) {
    router.push('/404')
  }
}
